export enum RabbitActionTypes {
  None,
  Download,
  SendReminder,
  CancelDocument,
  RefreshStatus,
}